import {
  ApiResponse,
  IDonViPdfExtra,
  IToaXeResponseBase,
  PaginationResponseBase,
} from "@/core/interfaces/ApiResponses";
import { apiServiceInstance } from "@/core/helpers/utils";

export default class ToaXeService {
  static async listAllByDanhMuc(
    id_danh_muc_toa_xe: number | null = 0,
    per_page = 100
  ): Promise<{
    items: IToaXeResponseBase[];
    extra?: IDonViPdfExtra;
  }> {
    const allItems: IToaXeResponseBase[] = [];
    let page = 1;
    let total = Infinity;
    let extra: IDonViPdfExtra | undefined;

    while (allItems.length < total) {
      const { data: response } = await ToaXeService.list(
        page,
        per_page,
        id_danh_muc_toa_xe
      );

      const {
        data: { data, total: totalItems },
      } = response;

      if (page === 1) {
        extra = response.extra as IDonViPdfExtra | undefined;
      }

      total = totalItems;
      allItems.push(...data);

      if (!data.length) break;
      page += 1;
    }

    return { items: allItems, extra };
  }

  static list(
    current_page = 1,
    per_page = 200,
    id_danh_muc_toa_xe: number | null = 0,
    search = "",
    id_don_vi?: number
  ): Promise<{
    data: ApiResponse<PaginationResponseBase<IToaXeResponseBase>>;
  }> {
    return apiServiceInstance().vueInstance.axios.get(
      "/api/v1/toa-xe/danh-sach",
      {
        params: {
          page: current_page,
          ...(id_danh_muc_toa_xe && {
            id_danh_muc_toa_xe,
          }),
          ...(search && {
            s: search,
          }),
          ...(id_don_vi && { id_don_vi }),
        },
        headers: {
          perpage: per_page,
        },
      }
    );
  }

  static get(id: number): Promise<{
    data: ApiResponse<IToaXeResponseBase>;
  }> {
    return apiServiceInstance().vueInstance.axios.get(
      `/api/v1/toa-xe/chi-tiet/${id}`
    );
  }

  static create({
    ten_toa_xe,
    ma_toa_xe,
    so_hieu,
    ghi_chu,
    id_dm_toa_xe,
  }: {
    ten_toa_xe: string;
    ma_toa_xe: string;
    so_hieu: string;
    ghi_chu?: string;
    id_dm_toa_xe: number;
    id_don_vi: number;
  }): Promise<{
    data: ApiResponse<IToaXeResponseBase>;
  }> {
    apiServiceInstance().vueInstance.axios.defaults.headers.common[
      "Content-Type"
    ] = "multipart/form-data";
    const bodyFormData = new FormData();

    bodyFormData.append("toaXeInstance[ten_toa_xe]", ten_toa_xe);
    bodyFormData.append("toaXeInstance[ma_toa_xe]", ma_toa_xe);
    bodyFormData.append("toaXeInstance[so_hieu]", so_hieu);
    bodyFormData.append("toaXeInstance[id_dm_toa_xe]", id_dm_toa_xe.toString());
    // bodyFormData.append("toaXeInstance[id_don_vi]", id_don_vi.toString());

    if (ghi_chu) {
      bodyFormData.append("toaXeInstance[ghi_chu]", ghi_chu);
    }

    return apiServiceInstance().vueInstance.axios.post(
      "/api/v1/toa-xe/tao-moi",
      bodyFormData
    );
  }

  static update({
    ghi_chu,
    id,
    ten_toa_xe,
    ma_toa_xe,
    so_hieu,
    id_dm_toa_xe,
  }: {
    id: number;
    ten_toa_xe: string;
    ma_toa_xe: string;
    so_hieu: string;
    ghi_chu?: string;
    id_dm_toa_xe: number;
    id_don_vi: number;
  }): Promise<{
    data: ApiResponse<IToaXeResponseBase>;
  }> {
    apiServiceInstance().vueInstance.axios.defaults.headers.common[
      "Content-Type"
    ] = "multipart/form-data";
    const bodyFormData = new FormData();

    bodyFormData.append("toaXeInstance[ten_toa_xe]", ten_toa_xe);

    bodyFormData.append("toaXeInstance[ma_toa_xe]", ma_toa_xe);
    bodyFormData.append("toaXeInstance[so_hieu]", so_hieu);
    bodyFormData.append("toaXeInstance[id_dm_toa_xe]", id_dm_toa_xe.toString());
    // bodyFormData.append("toaXeInstance[id_don_vi]", id_don_vi.toString());

    if (ghi_chu) {
      bodyFormData.append("toaXeInstance[ghi_chu]", ghi_chu);
    }

    return apiServiceInstance().vueInstance.axios.post(
      `/api/v1/toa-xe/cap-nhat/${id}`,
      bodyFormData
    );
  }

  static delete(id: number) {
    return apiServiceInstance().vueInstance.axios.post(
      `/api/v1/toa-xe/xoa/${id}`
    );
  }

  static validateToaXeData({
    so_hieu,
    ma_toa_xe,
  }: {
    so_hieu?: string;
    ma_toa_xe?: string;
  }) {
    return apiServiceInstance().vueInstance.axios.get(
      "/api/v1/validate/toa-xe",
      {
        params: {
          ...(so_hieu && {
            so_hieu,
          }),
          ...(ma_toa_xe && {
            ma_toa_xe,
          }),
        },
      }
    );
  }
}
